import { render } from "./ClassmatesList.vue?vue&type=template&id=820ee19a&lang=pug"
import script from "./ClassmatesList.vue?vue&type=script&lang=js"
export * from "./ClassmatesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__